export default __webpack_public_path__ + "img/fmMZZeFA.3efb9f5e.svg";